import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface AnonymousUserInterfaceProps {
  documentId?: string;
  expiresAt?: string;
  showUploadPrompt?: boolean;
  showRegistrationPrompts?: boolean;
  className?: string;
}

const AnonymousUserInterface: React.FC<AnonymousUserInterfaceProps> = ({
  expiresAt,
  showRegistrationPrompts = true,
  className = ''
}) => {
  const [timeLeft, setTimeLeft] = useState('');
  const [urgencyLevel, setUrgencyLevel] = useState<'low' | 'medium' | 'high'>('low');

  useEffect(() => {
    if (!expiresAt) return;

    const update = () => {
      const diff = new Date(expiresAt).getTime() - Date.now();
      if (diff <= 0) { setTimeLeft('Expired'); setUrgencyLevel('high'); return; }
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      if (days > 2) { setTimeLeft(`${days} days`); setUrgencyLevel('low'); }
      else if (days > 0) { setTimeLeft(`${days}d ${hours}h`); setUrgencyLevel('medium'); }
      else if (hours > 0) { setTimeLeft(`${hours}h ${minutes}m`); setUrgencyLevel('high'); }
      else { setTimeLeft(`${minutes} minutes`); setUrgencyLevel('high'); }
    };

    update();
    const timer = setInterval(update, 60000);
    return () => clearInterval(timer);
  }, [expiresAt]);

  if (!expiresAt) return null;

  const alertClass = urgencyLevel === 'high' ? 'alert-danger' : urgencyLevel === 'medium' ? 'alert-warning' : 'alert-info';

  return (
    <div className={`anonymous-user-interface ${className}`}>
      <div className={`alert ${alertClass}`} style={{ marginBottom: '16px' }}>
        <div className="d-flex align-items-center justify-content-between">
          <span>
            {timeLeft === 'Expired'
              ? 'This document has expired and is no longer available.'
              : <>Expires in <strong>{timeLeft}</strong></>}
          </span>
          {showRegistrationPrompts && timeLeft !== 'Expired' && (
            <Link to="/register" className="btn btn-sm btn-outline-primary" style={{ whiteSpace: 'nowrap', marginLeft: '12px' }}>
              Save forever
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnonymousUserInterface;
